import { Button, Empty } from "antd";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

const InsuranceConnectPrompt = ({ title, description, settingsLabel }) => {
    const history = useHistory();

    return (
        <div className="flex h-full min-w-0 flex-col items-center justify-center gap-4 px-2 py-12 text-center sm:px-4">
            <Empty
                description={
                    <div className="max-w-md">
                        <p className="text-lg font-semibold">{title}</p>
                        <p className="break-words text-gray-500">{description}</p>
                    </div>
                }
            />
            <Button
                type="primary"
                className="!h-11 w-full max-w-sm !rounded-xl sm:w-auto"
                onClick={() => history.push("/settings?menu=integration")}>
                {settingsLabel}
            </Button>
        </div>
    );
};

InsuranceConnectPrompt.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    settingsLabel: PropTypes.string.isRequired,
};

export default InsuranceConnectPrompt;
